export type DeletionSubject = 'event' | 'edition' | 'race'

export interface DeletionBlocked {
  subject: DeletionSubject
  paidRegistrationCount: number
}

const SUBJECTS: readonly string[] = ['event', 'edition', 'race']

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

/**
 * Returns the blocked-delete details for a 422 `paid_registrations_present`
 * response (issue #147, M2 deletion guard), otherwise null.
 */
export function parseDeletionBlocked(error: unknown): DeletionBlocked | null {
  if (!isRecord(error) || !isRecord(error['response'])) return null

  const response = error['response']
  if (response['status'] !== 422) return null

  const data = response['data']
  if (!isRecord(data) || data['error'] !== 'paid_registrations_present') return null

  const subject = data['subject']
  if (typeof subject !== 'string' || !SUBJECTS.includes(subject)) return null

  const count = data['paid_registration_count']

  return {
    subject: subject as DeletionSubject,
    paidRegistrationCount: typeof count === 'number' ? count : 0,
  }
}

/** i18n key of the blocked-delete message for a subject. */
export function deletionBlockedMessageKey(subject: DeletionSubject): string {
  return `deletion_blocked.paid_registrations.${subject}`
}
